<style lang="less" scoped src="@/assets/less/manage-space/base.less"></style>

<template>
    <div>
        <b-overlay :show="loading" class="h-100">
            <div class="bg-white round-unify-xs p-4 h-100" v-if="space">
                <b-form ref="form0">
                    <div class="w-100 block">
                        <div class="w-100 mb-2 mt-0">
                            <b-form-group
                                id="input-group-title"
                                :label="$t('labels.name')"
                                label-for="input-title"
                                label-class="label-align"
                                aria-describedby="title-description"
                            >
                                <b-form-input
                                    id="input-title"
                                    v-model="space['Name']"
                                    type="text"
                                    required
                                    :placeholder="$t('placeholders.spacename')"
                                    class="rounded-pill"
                                ></b-form-input>
                                <b-form-text id="title-description" class="ml-3">{{
                                    $t('messages.communityNameHelp')
                                }}</b-form-text>
                            </b-form-group>

                            <b-form-group
                                id="input-group-support-url"
                                :label="$t('labels.helpurl')"
                                label-for="input-help-url"
                                label-class="label-align"
                                aria-describedby="help-description"
                            >
                                <b-form-input
                                    id="input-help-url"
                                    v-model="space['SupportURL']"
                                    type="text"
                                    :placeholder="$t('placeholders.supporturl')"
                                    class="rounded-pill"
                                ></b-form-input>
                                <b-form-text id="help-description" class="ml-3">{{
                                    $t('messages.helpUrlDescription')
                                }}</b-form-text>
                            </b-form-group>

                            <b-form-group
                                id="input-group-DisclaimerForEmail"
                                :label="$t('labels.emailfooter')"
                                label-for="input-DisclaimerForEmail"
                                label-class="label-align"
                                aria-describedby="DisclaimerForEmail-description"
                            >
                                <b-form-textarea
                                    id="input-DisclaimerForEmail"
                                    v-model="space['DisclaimerForEmail']"
                                    type="text"
                                    :placeholder="$t('placeholders.emailfooter')"
                                    class="form-control d-block"
                                    style="border-radius: 1rem"
                                ></b-form-textarea>
                                <b-form-text id="DisclaimerForEmail-description" class="ml-3">{{
                                    $t('messages.emailFooterHelp')
                                }}</b-form-text>
                            </b-form-group>
                        </div>
                        <!-- Footer start -->
                        <div class="d-flex justify-content-between mt-4">
                            <b-button
                                variant="outline-danger"
                                @click="hasHistory() ? $router.go(-1) : $router.push('/admin/settings')"
                                >{{ $t('labels.cancel') }}</b-button
                            >

                            <b-button variant="primary" @click="handleSubmit()">{{ $t('labels.save') }}</b-button>
                        </div>
                        <!-- Footer end -->
                    </div>
                </b-form>
            </div>
        </b-overlay>
    </div>
</template>

<script>
import axios from 'axios';
import EventBus from '@/eventBus';

export default {
    name: 'GeneralSettings',
    data() {
        return {
            loading: false,
            space: null,
        };
    },

    mounted() {
        this.getSpaceSettings();
    },
    methods: {
        hasHistory() {
            return window.history.length > 2;
        },

        handleSubmit() {
            this.loading = true;

            const data = JSON.stringify(this.space);
            axios({
                method: 'PUT',
                url: '/admin/space/settings',
                withCredentials: true,
                data,
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then((response) => {
                    this.loading = false;
                    if (response && response.data) {
                        this.space = response.data;
                        const msg = {
                            Message: this.$t('messages.changessaved'),
                            Details: '',
                        };
                        EventBus.$emit('INFO', msg);
                    }
                })
                .catch((error) => {
                    this.loading = false;
                    const msg = {
                        Message: this.$t('messages.spaceSettingsSaveFailed'),
                        Details: '',
                    };
                    EventBus.$emit('ERROR', msg);
                });
        },

        getSpaceSettings() {
            this.loading = true;
            axios({
                method: 'GET',
                url: '/admin/space/settings',
                withCredentials: true,
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then((response) => {
                    this.loading = false;
                    if (response && response.data) {
                        this.space = response.data;
                    }
                })
                .catch((error) => {
                    this.loading = false;
                    const msg = {
                        Message: this.$t('messages.spaceSettingsLoadFailed'),
                        Details: '',
                    };
                    EventBus.$emit('ERROR', msg);
                });
        },
    },
};
</script>
